import React, { Component, useRef } from "react";
import "../QuickScreener/styles/style.css";
import {
  TopBar,
  TopBarContent,
  LandingBody,
  ResultsBodyBox1,
  ResultsBodyBox1TopContent,
  ResultsBodyBox1BottomContent,
  Divider,
  DividerBox,
  DividerBoxText,
  LandingBodyBox,
  Centralise,
  SkillsBox,
} from "../QuickScreener/styles/Theme";
import {
  Grid,
  Dimmer,
  Header,
  Loader,
  Sidebar,
  SidebarPusher,
  Menu,
  Icon,
} from "semantic-ui-react";
import {
  qrcode,
  ServiceImage,
  InteractionImage,
  Action2Image,
  Action1Image,
  SpeakImage,
  AnalysisImage,
} from "./assets/aws/QuickScreenerImageMapping";
import configStore from "../QuickScreener/store";
import { fetchQuestionnaires } from "../QuickScreener/actions/questionnaires";
import { isBrowser } from "react-device-detect";
import { WithTranslation, withTranslation } from "react-i18next";
import { DesktopOrLaptop, TabletOrMobile } from "../QuickScreener/MediaQuery";
import { Dropdown } from "semantic-ui-react";
import i18n from "i18next";
import Footer from "../QuickScreener/Footer";
import axios from "axios";
import api_address from "constants/config";
import Cookies from "js-cookie";

interface ResultsProps extends WithTranslation {
  match: {
    params: {
      transactionId: string;
      finalScore: string;
      questionnaireId: string;
      sexSel: string;
      dateSel: string;
      agentId: string;
    };
  };
}

interface ResultsState {
  questionnaireId: number;
  finalScore: number;
  sexSel: string;
  dateSel: string;
  result: string;
  milestone: any[];
  milestone_hidden: boolean;
  know_more_hidden: boolean;
  know_more: string;
  recommendation: string;
  recommendation2: string;
  cnLearnMoreLink: string;
  twLearnMoreLink: string;
  cnLearnMoreButtonText: string;
  twLearnMoreButtonText: string;
  active: boolean;
  visible: boolean;
  productRec: string;
  pass: boolean;
  qsResultId: number;
}

class Results extends Component<ResultsProps, ResultsState> {
  contactUs: React.RefObject<HTMLDivElement>;
  constructor(props: ResultsProps) {
    super(props);
    this.state = {
      questionnaireId: 0,
      finalScore: 0,
      sexSel: "",
      dateSel: "",
      result: "",
      milestone: [],
      milestone_hidden: true,
      know_more_hidden: true,
      know_more: "",
      recommendation: "",
      recommendation2: "",
      cnLearnMoreLink: "",
      twLearnMoreLink: "",
      cnLearnMoreButtonText: "",
      twLearnMoreButtonText: "",
      active: true,
      visible: false,
      productRec: "",
      pass: false,
      qsResultId: 0,
    };
    this.handleScrollToElement = this.handleScrollToElement.bind(this);
    this.contactUs = React.createRef();
    this.handleVisible = this.handleVisible.bind(this);
  }

  handleOpen = () => this.setState({ active: true });
  handleClose = () => this.setState({ active: false });

  handleMobileChange(lang) {
    if (lang === "简体中文 (Chinese - Simplified)") {
      i18n.changeLanguage("zh-CN");
      this.handleVisible(false);
    } else if (lang === "繁體中文 (Chinese - Traditional)") {
      i18n.changeLanguage("zh-TW");
      this.handleVisible(false);
    }
  }

  handleVisible(boolean) {
    this.setState({ visible: boolean });
  }

  codeToText(languageCode) {
    if (languageCode === "zh-CN") {
      return "简体中文 (Chinese - Simplified)";
    } else if (languageCode === "zh-TW") {
      return "繁體中文 (Chinese - Traditional)";
    }
    return;
  }

  handleChange(event) {
    const lang = event.currentTarget.textContent;

    if (lang === "简体中文 (Chinese - Simplified)") {
      i18n.changeLanguage("zh-CN");
    } else if (lang === "繁體中文 (Chinese - Traditional)") {
      i18n.changeLanguage("zh-TW");
    }
  }

  componentDidMount() {
    document.body.style.backgroundColor = "#f5b5b5";
    i18n.changeLanguage("zh-TW");
    const {
      transactionId,
      finalScore,
      questionnaireId,
      sexSel,
      dateSel,
      agentId,
    } = this.props.match.params;
    const { t } = this.props;
    if (parseInt(finalScore) >= 2) {
      // this block is for DELAYED result
      this.setState({
        result: t("quickScreener.results.result1"),
        cnLearnMoreLink: "https://qierbao.cn",
        cnLearnMoreButtonText: t("quickScreener.results.learnmore"),
        twLearnMoreButtonText: "啟動早療服務",
        twLearnMoreLink:
          "https://eval.qierbao.com/purchases-payment?product=CustomizedPrivateCoachingTrial&currency=twd",
        recommendation: t("quickScreener.results.recommendation1"),
        recommendation2: t("quickScreener.results.recommendation1pt2"),
        pass: false,
      });
    } else {
      // this block is for NORMAL result
      this.setState({
        result: t("quickScreener.results.result2"),
        cnLearnMoreLink: "https://qierbao.cn",
        cnLearnMoreButtonText: t("quickScreener.results.learnmore"),
        twLearnMoreButtonText: "健康守護圈",
        twLearnMoreLink: "https://health.nanshanlife.com.tw",
        recommendation: t("quickScreener.results.recommendation2"),
        recommendation2: t("quickScreener.results.recommendation2pt2"),
        pass: true,
      });
    }
    this.getMilestone(parseInt(questionnaireId));

    this.setState({
      finalScore: parseInt(finalScore),
      questionnaireId: parseInt(questionnaireId),
      sexSel: sexSel,
      dateSel: dateSel,
    });

    const qsResultData = {
      transactionId: transactionId,
      finalScore: finalScore,
      questionnaireId: questionnaireId,
      sex: sexSel,
      dob: dateSel,
      agentId: agentId ?? "",
    };

    this.checkResultOnComponentLoad(qsResultData);
  }

  async findMatchingEntry(prevQsResults, questionnaireId, sex, dob) {
    for (const qsResult of prevQsResults) {
      const date = new Date(qsResult.dob);
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed in JavaScript
      const day = date.getDate().toString().padStart(2, "0");
      const year = date.getFullYear();

      const formattedDob = `${month}-${day}-${year}`;
      if (
        qsResult.questionnaireId === questionnaireId &&
        qsResult.sex === sex &&
        formattedDob === dob
      ) {
        return qsResult.id; // Matching entry found
      }
    }
    return 0; // No matching entry found
  }

  async checkPreviousResult(questionnaireId, sexSel, dateSel) {
    const token = Cookies.get("token");
    const res = await axios.get(
      api_address + "api/quickScreenerResult/getQSResultByUserId",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const { status, message, qsResult } = res.data;

    if (!status) {
      throw new Error(message);
    }
    const prevResultId = await this.findMatchingEntry(
      qsResult,
      questionnaireId,
      sexSel,
      dateSel
    );

    return prevResultId;
  }

  async submitResult(qsResultData) {
    const token = Cookies.get("token");
    const res = await axios.post(
      api_address + "api/quickScreenerResult",
      qsResultData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const { status, message } = res.data;
    if (!status) {
      throw new Error(message);
    }
    return res;
  }

  async checkResultOnComponentLoad(qsResultData) {
    const { questionnaireId, sex, dob } = qsResultData;

    // IMPORTANT NOTES:
    // Need to add logic about for the case: if it's twins kid and having same dob and same gender
    // const purchasesRes = await axios.get(api_address + "api/user/purchases", {
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //   },
    // });
    // const { status: purchaseStatus, message: purchaseMessage } =
    //   purchasesRes.data;
    // if (!purchaseStatus) {
    //   throw new Error(purchaseMessage);
    // }
    // const orders = purchasesRes.data.orders;
    // const qsOrders = orders.filter((order) => order.name === "QuickScreener");

    // console.log(orders, "orders debug", qsOrders);
    // if (qsResult.count >= qsOrders.count) {
    //   console.log("masuk debug");
    //   return;
    // }

    const prevResultId = await this.checkPreviousResult(
      questionnaireId,
      sex,
      dob
    );

    if (prevResultId === 0) {
      const res = await this.submitResult(qsResultData);
      this.setState({ qsResultId: res.data.qsResult.id });
      return;
    }
    this.setState({ qsResultId: prevResultId });
  }

  componentDidUpdate(prevProps) {
    // Check if the translation function has changed (indicating a language change)
    if (prevProps.t !== this.props.t) {
      const { finalScore } = this.props.match.params;
      const { t } = this.props;

      if (parseInt(finalScore) >= 2) {
        // this block is for DELAYED result
        this.setState({
          result: t("quickScreener.results.result1"),
          cnLearnMoreLink: "https://qierbao.cn",
          cnLearnMoreButtonText: t("quickScreener.results.learnmore"),
          twLearnMoreButtonText: "啟動早療服務",
          twLearnMoreLink:
            "https://eval.qierbao.com/purchases-payment?product=CustomizedPrivateCoachingTrial&currency=twd",
          recommendation: t("quickScreener.results.recommendation1"),
          recommendation2: t("quickScreener.results.recommendation1pt2"),
          pass: false,
        });
      } else {
        // this block is for NORMAL result
        this.setState({
          result: t("quickScreener.results.result2"),
          cnLearnMoreLink: "https://qierbao.cn",
          cnLearnMoreButtonText: t("quickScreener.results.learnmore"),
          twLearnMoreButtonText: "健康守護圈",
          twLearnMoreLink: "https://health.nanshanlife.com.tw",
          recommendation: t("quickScreener.results.recommendation2"),
          recommendation2: t("quickScreener.results.recommendation2pt2"),
          pass: true,
        });
      }
    }
  }

  componentWillUnmount() {
    // Reset the background color when the component unmounts
    document.body.style.backgroundColor = "initial";
  }

  getMilestone = (questionnaireId) => {
    const store = configStore();
    return store.dispatch(fetchQuestionnaires()).then(() => {
      const questionnaires = store.getState().questionnaires.list;
      const questionnaire =
        questionnaires.find((item) => item.id === questionnaireId) || {};
      this.setState({ milestone: questionnaire.milestone });
      this.handleClose();
      return questionnaire.milestone || [];
    });
  };

  EndingNotesZHTW = (qsResultId) => {
    return (
      <>
        <br />
        <Centralise>
          <h2>【了解發育里程碑】</h2>
        </Centralise>
        <br />
        <p>
          您知道以上這些領域您孩子該達到什麼能力階段嗎？我們整理了最新的國際標準發育里程碑（美國CDC2022出版）供您參考。
        </p>
        <br />
        <Centralise>
          <button
            onClick={(e) => {
              window.open(
                "https://tcn.mypenguinsmart.com/blog/cdc-development-2022?categoryId=18413",
                "_blank" // <- This is what makes it open in a new window.
              );
            }}
            style={{
              textAlign: "center",
              borderRadius: "50px",
              backgroundColor: "#6898e3",
              color: "white",
              cursor: "pointer",
              border: "none",
              padding: "10px 50px 10px 50px",
              outline: "none",
            }}
          >
            查看發育里程碑
          </button>
        </Centralise>
        <br />
        <Centralise>
          {/* <i>{`** 技術回報用 Result ID： ${qsResultId} **`}</i> */}
          <p
            style={{ color: "gray", fontSize: "12px" }}
          >{`* 技術回報用 Result ID： ${qsResultId}`}</p>
        </Centralise>
        <br />
      </>
    );
  };

  renderSkills = () => {
    const imageArr = [SpeakImage, Action1Image, Action2Image, InteractionImage];
    const { t } = this.props;

    if (this.state.milestone.length === 0) {
      return (
        <Dimmer
          active={this.state.active}
          onClickOutside={this.handleClose}
          page
        >
          <Header as="h2" icon inverted></Header>
          <Loader />
        </Dimmer>
      );
    } else {
      return (
        <div>
          <SkillsBox device={isBrowser ? "browser" : "mobile"}>
            <Grid>
              <Grid.Row style={{ padding: 0 }}>
                <Grid.Column width={isBrowser ? 3 : 5}>
                  <img style={{ width: "auto" }} src={imageArr[0]} />
                </Grid.Column>
                <Grid.Column width={isBrowser ? 13 : 11}>
                  <h3 style={{ margin: "1px" }}>
                    {t(this.state.milestone[0].name)}
                  </h3>
                  <p> {t(this.state.milestone[0].text)}</p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </SkillsBox>
          <SkillsBox device={isBrowser ? "browser" : "mobile"}>
            <Grid>
              <Grid.Row style={{ padding: 0 }}>
                <Grid.Column width={isBrowser ? 3 : 5}>
                  <img style={{ width: "auto" }} src={imageArr[1]} />
                </Grid.Column>
                <Grid.Column width={isBrowser ? 13 : 11}>
                  <h3 style={{ margin: "1px" }}>
                    {t(this.state.milestone[1].name)}
                  </h3>
                  <p> {t(this.state.milestone[1].text)}</p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </SkillsBox>
          <SkillsBox device={isBrowser ? "browser" : "mobile"}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={isBrowser ? 3 : 5}>
                  <img style={{ width: "auto" }} src={imageArr[2]} />
                </Grid.Column>
                <Grid.Column width={isBrowser ? 13 : 11}>
                  <h3 style={{ margin: "1px" }}>
                    {t(this.state.milestone[2].name)}
                  </h3>
                  <p> {t(this.state.milestone[2].text)}</p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </SkillsBox>
          <SkillsBox device={isBrowser ? "browser" : "mobile"}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={isBrowser ? 3 : 5}>
                  <img style={{ width: "auto" }} src={imageArr[3]} />
                </Grid.Column>
                <Grid.Column width={isBrowser ? 13 : 11}>
                  <h3 style={{ margin: "1px" }}>
                    {t(this.state.milestone[3].name)}
                  </h3>
                  <p> {t(this.state.milestone[3].text)}</p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </SkillsBox>
        </div>
      );
    }
  };

  handleScrollToElement(event) {
    this.contactUs.current?.scrollIntoView({ behavior: "smooth" });
  }

  render() {
    const {
      result,
      sexSel,
      dateSel,
      milestone,
      recommendation,
      recommendation2,
      cnLearnMoreLink,
      twLearnMoreLink,
      cnLearnMoreButtonText,
      twLearnMoreButtonText,
      know_more,
      productRec,
      qsResultId,
    } = this.state;
    const { t } = this.props;
    if (productRec.includes("✔")) {
      console.log("have");
    }
    const questionnaireSource = t("quickScreener.results.questionnaireSource");
    const BriefImageBase64 =
      "data:image/png;base64,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" +
      "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" +
      "IpnnHz4roWc9ee51+7KjmWVdHJAu9tDTJTjBhAtFnn2nrifUeo3hmpQ/pS/qEgQAIgAAIgECEEzBEyHZwRaea+jp64r67aUfFNs2RxsbGksTK6mVdnSJk9WrduHYtFVrg7ZEVDJJ3dN06c6tniZjW2iTFlnh5JZ5Vb5M+pC/p02yLNuT/XsyeJfoHARAAARAwkYAhf2m2VVU6ptjBj+jvuO4qXaY764xf6NKuNBopHlkrhRYM8+VBl5RXemYM8Pctkb63bPF3RvDHpNiB5IldvTr4a0O9QvqSPnUqRqJ6WBCyqlHhRBAAARAAgdAIGCJkKyqdQlaG+MWCT+jNl18IbbR+rho9bjxNnLqXnzNCP+QQshGx2MtYt7K/0IIxI0b6viHyaF8WXBltP/ygfSowqdglcwklxVao85e+pE/p20yzWjowM1mgbxAAARAAAV0IGCJkd9Z7rki/7883UZWU/9TY9PLKOkMLIiFGlgWOgSZlhH3Z6OF+hKxcJJkMduzwdbn2+yUNmB7iWapwbdf+ux4QgORvlr7NNHhkzaSPvkEABEBgSBAwRMjWyAIaN2th0XDb1Ve47dHm41GzTqb4hARtGnNrJVJCC3p6jfXIZmRlu1Ec+BjFnrrRJcMHdvj6JPmHjRKzUlxAa697cjJxnV5dq9v5QueoACZ9yxjMMp3zO5s1LfQLAiAAAiBgHQKGCNnahsGrwBd/Op9ef+k5zUi0cLXO7qgM+tmR2ieF7+3p1lzjaDbxIBrq6THWq5ydm6s4uuKCQkpKVLmqXsSs3h5NCWXQoyiDZGbQs8ytIl23ndK3d3YIt8O6f4yL070LdAACIAACIDC0CRgiZCVjgZLdf9ufws5iIFmxqrj5Ko5eaGnuoZGjRil1Fda+hKRkio7mqkw2tx4j4zSZVVZ2jiKxg/aeprjf504Rs+Ix1cPEC7tsmR4tO1NgtfMvLLNM+jYzDZereptZ80e/IAACIAACEU/AECHb1MqeIQVrZY/RLVdeFnLVrPZOdqTxOrKWNqJY6qGC3irqrN6p0FN4uxISkigmEoRsj7GhBZk+hOzP9jswuBsiuc9WrSL68kvtU3OtXUvkFfoS3OD8nC2P9iFk/QDCIRAAARAAARAIj4AhQra1jZWmD/t68ef0wj8e83FUebc40Woa+IlzNefP5/VLSdROw3srKKG/i845azYlxGsbJxspHlmj02/FcIxkRmaWx03M4Pyxe5cHmePUFbsqqbEWLOB8aPwLRgsTAbtypRYtoQ0lAggtUKKCfSAAAiAAAhoSMEbIcv5Yf/bw3bfTujXscVNhnd1E29jp2rjLyZvZ30hFvZUUTU5vYw57AU89+VQVLak/JTEphUML1J9v1TONLoggHLJyPMMLxBsbEyxM92oUNTVEH35ItDNMz7sUX/jiC+09vO43X4oTmPloX/o20yOM0AL3bwM+gwAIgAAI6EDAEHnWEkDIdrOouOGyi7nwAP/h92P1TUQVVf3UxWJWhGtBXzXl9A2Ovz3vF+dSYgI/1tXIEhIjJEbW4NACwZ+VM1A6OI4rsP06lApsLo+s636KOFu40Bk36y5yXccDvXfzF0iu9/OkIFATqo6bHaNqtpCV0AoYCIAACIAACOhIwBAh29PdE3AKG9auoQfvuFXxPLm8gh1wdSxk+ynKEQ9b1LeDUvuVY2/FK3vmaWcothXKTgktiIQYWaNDC4S1e+aCUzijRElhUfC3QEmsiriVuNlgvbPyY0lErGQq0NtaW4lSU/XuxXf70reMwSwzM/WXWXNGvyAAAiAAAoYSMEbI9qlLxP/y00/RZ5/wY2M3a+K/w9sq+6mDnwSLJfV3UMmueFjnHuV/z5v9K0pLS1M+GOTeBE4VFRFZCySg2GDLzS9w9JjC3sGLTj87tN6VhKyrpSb+dSNxsxImEEicSk7aDz7Qb3GXa0yud/H4inDOG/BKuw7p/i6pz6Rvvb3O/iZiZliFv3HhGAiAAAiAQMQQiDViJn1BpH265Q+/o/98sICy8wppJ0cNtDmiDaIcw8zob6LcPs8qYb7Gn84i9vxzz6eHHn3I1ymq92c11mAAAAvTSURBVGdyYn9J4m936zEhtOCKCy+lOYcfQ5L0QXXuWG/Q3qEF3sdlW1J0ySs/n2jECKICFtDyaFs8kiJw168nqlX33VFqPuR9UmGriL3Q1bwy0UiTql7St1kmcdAILTCLPvoFARAAgSFDwBAhyw+BVVtDXS29+MyLNGv276mv3ykeozigIK+/htL6lEMJfDV+1iln0MuvvExVO7ncaRg2vHR0GFdb59Ke3mDuhDbjjueE/PHheub8eWS9hymLwMJdCObdZjjbIq5nznTG8wbxgy6cLkkqaomYlxAKsyzce27WuNEvCIAACICArQgYElogi3zU2qXXP0DH/+LK3SI2tr+Hint3BC1ipb+EhHj6zf9dqrZrxfNi4+Ipx4xHw4qjCW+nGVkLSIsUTEYJwPDwKl8toQ+VlURlZcrH9dgrfUmf0rdZZmZFMbPmjH5BAARAAAQMJ2CIkI0PQsx888XHDMHpOYzvb6eS/u2UQKHnDT3u6GNpUvnEkMHmFhRzBgT2cEWAmRFaQFqkYOoJvFjQ0rdHqpKNGWPMo3Z5nC996VUJTS3o9HS1Z+I8EAABEAABEAiZgCFCNi5Wfc31Lxe8Q8889CdaOO9levquyymmP7wFShKccPUVV4UMKL9oBGuxyBCyZmQt0ETISs5XO5uk4Vqzhujgg8nx2F+vuUhIgfQhfZmZP1bmp9FCS71QoV0QAAEQAIHIIKD+mX8Y801JTqG6Ri7FpdLe/c/ju88cNXyEo1rX7h0hfJhUNpFOOPZ4evu9d4K+Oq+whBLiIkPImhJaIIt+RGCFEx5gd4+sfOt+/JEoI4PoVC7WMXdu0N9DVRcccABXCml09qXqAh1PgpDVES6aBgEQAAEQcBEwxCObEUYuzQcf+zt98eVi13hDfr/sojmUEkLcXp7DI2sIppDnpvZCU0ILZHAJYZQMFhEbzGIvtTDMOG/pUmcWhYMO0tYzKz8UzuC8ySKUv/rKjJl59ik/XkL4b82zEWyBAAiAAAiAQGAChii09JTQk8L3sYi57pYbaNOWLYFn4+eMXC6V+rtLfuvnDOVDw4pLKS7WEEzKA9Bwry2FrFThiiR77z0iCZU49FBtYmYlJlba2ryZ6N13Obzc+MwUg26PxMdGQLq6QfPCDhAAARAAAcsRMESh5WRlhTXxlpYWuuLaK6mpuTmsdk496RTac8qeQbWxR1l5ROSQlUn39vYFNXfNTg7HIxtpQlaEpnhmt24lOuoookmTQvPOihdWrpU2pC1p0yoW5n/vVpkGxgECIAACIGB9AoYI2fyc3LBJbKv4ia656Y/UE0aspSz8uvGaGyhO5Ur6tPQsGj5ieNhjt0oD8Mha5U7wOCRmVsrrSr7VY48lmjpVXQUwSQUn58o1cq20IW1ZySBkrXQ3MBYQAAEQiGgChiz2KsjRpkTnV8u+or89eB9de+XVId+UUSNH0gW/PJ8ef+qJgG2MLt+TUpINQRRwLFqc0GNHj6zdMxb4u3GSWUBiWuVRfEkJ0Z78tEBCBfgJhCPrgCvzgAhWeUmsuZSdlYpdUuzAzDyx/uYFIeuPDo6BAAiAAAhoSMAQlVZSUKjZkOe+/l8aM3oMncZhAqHaebN/RQsXfUqr16z228TY8r0oJUl96jC/jVngIDyyFrgJSkMQQbpqlfOVnOxcKCXC1VXiVUrsiqiVcrttbUotWGefjD+cUBLrzAQjAQEQAAEQsAEBQ0ILRhazt0lDu+fBe+nr5d+E3KJUGrvj5ttYJ7BY8GNTph3AhakMQeRnFNodsp1HVryxYYSSaEfOwJZEqFZXO+Ne164lkpfEwMo+q4tYwZSdbSAsdAUCIAACIDDUCRii0gpz8/jJKHtqNLIeTsl0zY3X0rbt/Ig1RBtRMoKuueIPPq+O4cU0EyZN8XncjgdM88jKCvZQvHTyGB1mLwIRUs7ZXtAxWhAAARAYugQMEbKCd+z4CZpSbmxqpN//8Q/UGoaX6sTjZtFhPztMcVzDx5RRZrp24luxE4N3mpa1QObpekwezJxdMaLBXINzzSMgP1hyw1/Yad4E0DMIgAAIgIDdCBgmZMt08G5u3LSRbrj1JuoLI3fmjddcT8VFxYPu25iyyFroJRM0zSMrnQfrkZV7Co+skLOPZWYSx+LYZ7wYKQiAAAiAgO0JGCNk2VMzed/pusD67IvP6O+PPxxy2+lcSvP+v/5tUNWvqdMPpoR4ztUZQdbba2Ky/GCFrOSPjZSKXhH0HfI7FYQV+MWDgyAAAiAAAtoTMEbIsoiZqlCIYNSYPSghlEfOXhyeffE5eveDeV571W+OGTWaF3/9xaPwwb4HHOixrb41a59pmlc22PuMsAJrf5GURldQoLQX+0AABEAABEBANwKGCdkiXvBVlO/5h27G3tNo2kRtFlTddvft9N0P34cM6qADZtDlv/md4/rhoydQXi4/Jo1AM03IBuuRhZC117dPcuHy0w0YCIAACIAACBhJwBghK944jnnc/7AjPOaWxmmwDtl3P499oW50c6qmq264mqqqd4baBJ171my68FcXcBjEDEpNicxYP1uk4EJ8bMjfYdMuLB4cZ27aWNAxCIAACIDAkCFgjJCVRO68COSQcWUeYLs4DvJgDWNna2tr6co/XkXtnaGlbZJFY5deeDHdcMmFFN/BYxZBFWHW29Nnzoyi+aumdiGQZKKIQPbmgDegV8lWUFRkQEfoAgRAAARAAAQ8CRgjZKXk5urVtF/ZJK6UNVCEYGdtDeVn51DZmLGeowpja83aNXTL7bdSsBJUzo+WP8hsiXG8yKuulmj7NqLmZse+SPnHNI+sAFQbXiA/fGD2ISApt9TeW/vMCiMFARAAARCwAQFjhOwuEPHskTt0/xm7sazfusXxWavwAlfDH8//hJ789z9cm6reo3aJWI+TufAC1dVwbXsWtK0sxiPATIuRFXZqxI5U8gojN3AE3CL7TQFhBfa7ZxgxCIAACEQIgVij53HiYUfS2/M/dnS78act1L0rvOCJl58PeihxLIwLc/OpmFdLy0Ky4vxCfs+nYfxeLAvLpMRpfLy6dv09yu7hVFA1XCK0qYkoi0twBrsCX90IDDmrp4eFolmmRsgirMCsuxNavxznTshWEBo7XAUCIAACIBA2AcOF7F4cXjB25Chat2UTdbLQXLFmFU2bPNURYrBTHue7WSyXic3PyXWIUoc4FcGa5xStRQWFlMeiUtGT6mqjkcMCsjj7QKyPfLDihfUnYF3tuN67OomqdhAlp3BN+RwiHp/dzNRcsmp+VERYKIfdvh9Bj3fYMFv+dxD0PHEBCIAACICAJQkYLmSFwnmnnEF//ccjVJCdS1UcJyt20ZmzqaqmxuFddXlURcTGyCKhUE1EaqN4UTM4AFahHbUi1hV24Dq/jWM4O9qd3tlUe6UcsnRogRRB6OQfCzD7EEBYgX3uFUYKAiAAAhFIwBQhe/RBM0le7nby4Ue7b2r3WWIum9gzm8li1t1kdZdzbZf7XuXPImAlpEBEq4QZSOlUeTU1OlfiJ3B6MZuYpUMLZFEgzD4EZOFmNv93AQMBEAABEAABkwiYImQNn2sXi89mFklpqQNdqxWxrivq65yf0lkQxycQybsNrcfMMrWBQgsgZO31jSottdd4MVoQAAEQAIGII6DwvD3i5uicUDt7UOUl5goVcG6p/1fErHhhbWymhhYId19iVhZ5SZYImD0IyH0cMcIeY8UoQQAEQAAEIpbA0BGycgvFK9vJmQxcsa6h3Fabi1lTQwuEty8h29AQyt3ANWYREG+sDRc7moUL/YIACIAACOhDYGgJWWEoi79cntlQmYqYbeZ2bGimZi0QXkpCtp0XzmGRl32+TVKhbeRI+4wXIwUBEAABEIhYAkNPyMqtFM9sC2ceCCbEQLxP7iJMUoW12K/ql6mhBcJeKZcsvLFCxj4mIlZtuWH7zAojBQEQAAEQsCGBoSlk5Ua1sRewgb2qkr1AjUn2A0n+nuq2YEzErKTispFZLrTAlQHCRgyH9FDlBx0WeQ3prwAmDwIgAAJWIvD/X+XQ9lCVqE0AAAAASUVORK5CYII=";

    const languageOptions = [
      {
        key: "繁體中文 (Chinese - Traditional)",
        text: "繁體中文 (Chinese - Traditional)",
        value: "繁體中文 (Chinese - Traditional)",
      },
      {
        key: "简体中文 (Chinese - Simplified)",
        text: "简体中文 (Chinese - Simplified)",
        value: "简体中文 (Chinese - Simplified)",
      },
    ];

    return (
      <div>
        <Sidebar
          as={Menu}
          animation="overlay"
          icon="labeled"
          inverted
          onHide={() => this.handleVisible(false)}
          vertical
          visible={this.state.visible}
          width="thin"
          style={{ backgroundColor: "white" }}
        >
          <br />
          <a
            className="waves-effect waves-light btn-medium teal-text text-accent-4"
            onClick={() => this.handleVisible(false)}
          >
            <Icon name="angle double left" />
            <b>Hide</b>
          </a>
          <br />
          <br />
          <Menu.Item
            as="a"
            style={{ color: "black" }}
            onClick={() =>
              this.handleMobileChange("繁體中文 (Chinese - Traditional)")
            }
          >
            繁體中文 (Chinese - Traditional)
          </Menu.Item>

          <Menu.Item
            as="a"
            style={{ color: "black" }}
            onClick={() =>
              this.handleMobileChange("简体中文 (Chinese - Simplified)")
            }
          >
            简体中文 (Chinese - Simplified)
          </Menu.Item>
        </Sidebar>
        <SidebarPusher>
          <TopBar page="questionnaire">
            <DesktopOrLaptop>
              <Dropdown
                button
                className="icon left"
                labeled
                icon="world"
                options={languageOptions}
                text={this.codeToText(this.props.i18n.language)}
                onChange={this.handleChange}
                style={{
                  display: "float",
                  float: "left",
                  marginTop: "0.8rem",

                  marginLeft: "2rem",
                }}
              />
            </DesktopOrLaptop>
            <TabletOrMobile>
              <div className="sideMenu"></div>
              <Icon
                style={{
                  display: "float",
                  float: "left",
                  marginTop: "1.5rem",
                  paddingLeft: "2rem",
                  cursor: "pointer",
                  paddingBottom: "0.5rem",
                }}
                onClick={() => this.handleVisible(true)}
                name="globe"
                color="black"
                size="big"
              />
            </TabletOrMobile>
            <TopBarContent>
              <p
                style={{
                  // display: "inline-block",
                  // ...(isBrowser
                  //   ? { marginRight: "22rem" }
                  //   : { marginRight: "1rem", marginTop: "0.2rem" }),
                  display: "inline-block",
                  paddingTop: "1rem",
                  fontSize: "2.3rem",
                  ...(isBrowser
                    ? {
                        marginRight: "22rem",
                      }
                    : {
                        marginRight: "1rem",
                      }),
                }}
              >
                {t("quickScreener.results.conclusion")}
              </p>
            </TopBarContent>
          </TopBar>
          <LandingBody page="pink">
            <Grid>
              <Grid.Row style={{ margin: 0 }}>
                <Grid.Column width={isBrowser ? 5 : 1}></Grid.Column>
                <Grid.Column width={isBrowser ? 6 : 14}>
                  <ResultsBodyBox1>
                    <ResultsBodyBox1TopContent
                      style={{
                        backgroundImage: `url(${BriefImageBase64})`,
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <Grid>
                        <Grid.Row style={{ margin: 0 }}>
                          <Grid.Column width={isBrowser ? 7 : 8}></Grid.Column>
                          <Grid.Column width={isBrowser ? 9 : 8}>
                            <strong>
                              <p
                                style={
                                  isBrowser
                                    ? { fontSize: "18pt", color: "#4183c4" }
                                    : { fontSize: "18pt", color: "#4183c4" }
                                }
                              >
                                {`${result}`}
                              </p>
                            </strong>
                            <br />
                            <p
                              style={
                                isBrowser
                                  ? {
                                      fontSize: "12pt",
                                    }
                                  : {
                                      fontSize: "12pt",
                                    }
                              }
                            >
                              {recommendation}
                            </p>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </ResultsBodyBox1TopContent>
                    <ResultsBodyBox1BottomContent
                      device={isBrowser ? "browser" : "mobile"}
                    >
                      <p>{recommendation2}</p>

                      <Centralise>
                        <button
                          // onClick={this.handleScrollToElement}
                          onClick={(e) => {
                            window.open(
                              i18n.language === "zh-CN"
                                ? cnLearnMoreLink
                                : twLearnMoreLink,
                              "_blank" // <- This is what makes it open in a new window.
                            );
                          }}
                          style={{
                            textAlign: "center",
                            borderRadius: "50px",
                            backgroundColor: "#6898e3",
                            color: "white",
                            cursor: "pointer",
                            border: "none",
                            padding: "10px 50px 10px 50px",
                            outline: "none",
                          }}
                        >
                          {i18n.language === "zh-CN"
                            ? cnLearnMoreButtonText
                            : twLearnMoreButtonText}
                        </button>
                      </Centralise>
                      <Centralise>
                        {i18n.language === "zh-TW" &&
                          (this.state.pass ? (
                            <>
                              <br />
                              <p style={{ fontSize: "10px", color: "gray" }}>
                                服務相關內容與記錄均為客戶個資，南山不會獲得相關資料。健康守護圈之加值服務或合作廠商所提供之商品、服務及優惠，均非屬保險契約權利義務之一部分，本公司與合作廠商間亦無代理或類似關係。如遇使用問題請洽詢合作廠商取得相關協助
                              </p>
                            </>
                          ) : (
                            <>
                              <br />
                              <a href="https://lin.ee/5TuAhDA">聯絡LINE客服</a>
                              <br />

                              <br />
                              <p>注意事項：</p>

                              <div style={{ paddingRight: "2.5rem" }}>
                                <ol>
                                  1.
                                  專屬序號為16-20位數，包含大小寫英文、數字及橫槓。建議從簡訊中長按選擇複製文字並貼入。輸入序號，按“使用”後將可零元下單啟動服務。
                                </ol>
                                <ol>
                                  2.
                                  專屬序號領取限與發育篩查同一兒童，每個專屬序號限使用一次。
                                </ol>
                                <ol>
                                  3.
                                  若有多個兒童欲申請，需各別申請暖心關懷服務，並分別用不同的email註冊帳號&完成綜合篩查後分別領取早療服務。
                                </ol>
                                <ol>
                                  <p
                                    style={{ color: "gray", fontSize: "12px" }}
                                  >
                                    *服務相關內容與記錄均為客戶個資，南山不會獲得相關資料。健康守護圈之加值服務或合作廠商所提供之商品、服務及優惠，均非屬保險契約權利義務之一部分，本公司與合作廠商間亦無代理或類似關係。如遇使用問題請洽詢合作廠商取得相關協助
                                  </p>
                                </ol>
                              </div>
                            </>
                          ))}
                      </Centralise>
                    </ResultsBodyBox1BottomContent>
                  </ResultsBodyBox1>

                  <Divider>
                    <DividerBox>
                      <DividerBoxText>
                        {t("quickScreener.results.basicInfo")}
                      </DividerBoxText>
                    </DividerBox>
                  </Divider>
                  <LandingBodyBox>
                    <Grid>
                      <Grid.Row style={{ margin: 0, fontSize: "12pt" }}>
                        <Grid.Column width={isBrowser ? 8 : 9}>
                          <p>{t("quickScreener.results.bday")}</p>
                          <p>{t("quickScreener.results.gender")}</p>
                        </Grid.Column>
                        <Grid.Column
                          width={isBrowser ? 8 : 7}
                          style={{ textAlign: "right" }}
                        >
                          <p>{dateSel}</p>
                          <p>{sexSel}</p>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </LandingBodyBox>
                  <Divider>
                    <DividerBox>
                      <DividerBoxText>
                        {t("quickScreener.results.moreInfo")}
                      </DividerBoxText>
                    </DividerBox>
                  </Divider>
                  <LandingBodyBox
                    style={{ boxShadow: "-4px 4px 8px rgba(0, 0, 0, .15)" }}
                  >
                    <Grid
                      centered
                      style={isBrowser ? null : { marginBottom: "10px" }}
                    >
                      <Grid.Row>
                        {isBrowser && (
                          <Grid.Column width={3}>
                            <img
                              src={AnalysisImage}
                              style={{
                                height: "75%",
                                width: "auto",
                                display: "inline",
                              }}
                            />
                          </Grid.Column>
                        )}
                        <Grid.Column
                          width={isBrowser ? 5 : 9}
                          style={{ textAlign: "center" }}
                        >
                          <h2>{t("quickScreener.results.analysis")}</h2>
                          <p>{t("quickScreener.results.capability")}</p>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                    {this.renderSkills()}
                  </LandingBodyBox>
                  <LandingBodyBox
                    style={{
                      boxShadow: "-4px 4px 8px rgba(0, 0, 0, .15)",
                      marginTop: "20px",
                    }}
                  >
                    <Grid
                      centered
                      style={isBrowser ? null : { marginBottom: "10px" }}
                    >
                      <Grid.Row>
                        {isBrowser && (
                          <Grid.Column width={3}>
                            <img
                              src={ServiceImage}
                              style={{
                                width: "auto",
                                height: "80%",
                                display: "inline",
                                float: "right",
                              }}
                            />
                          </Grid.Column>
                        )}
                        <Grid.Column
                          width={isBrowser ? 6 : 10}
                          style={{ textAlign: "center" }}
                        >
                          <div ref={this.contactUs}>
                            <h2>{t("quickScreener.results.service")}</h2>
                            <p>{t("quickScreener.results.understandMore")}</p>
                          </div>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                    <p
                      style={{
                        textAlign: "justify",
                        fontSize: "12pt",
                        lineHeight: "1.5",
                      }}
                    >
                      {i18n.language === "zh-CN" && this.state.pass && (
                        <div>
                          <p>
                            感谢您使用本快筛小工具，希望对您有帮助。根据快筛结果恭喜您孩子的成长符合正常标准。
                            为您推荐：
                          </p>
                          <Centralise>
                            <p>CORE语言测评</p>
                          </Centralise>
                          <p>
                            {" "}
                            5沟通领域。10分钟。立马执行
                            家长自填观察型动态情景式自评问卷，10分钟即获得语言沟通5大领域的初步评估与活动推荐。
                            如果想进一步了解孩子的沟通能力情况，欢迎下方客服加启儿宝小助理微信好友(ID:
                            qierbaohelp )了解更多！
                          </p>
                        </div>
                      )}
                      {i18n.language === "zh-TW" && this.state.pass && (
                        <div>
                          <p>
                            感謝您使用本篩查工具，希望對您有幫助。根據結果，恭喜您孩子的成長符合正常標準。
                            本篩查工具7歲前可每半年至一年定期重新檢測，將有新的對應題組。如果想進一步了解孩子的溝通發育能力情況，歡迎下方客服諮詢啟兒寶LINE@了解更多！（@penguinsmart)
                          </p>
                          <br />
                          <Centralise>
                            <h2>- - 啟兒寶其他推薦 - -</h2>
                          </Centralise>
                          <br />
                          <Centralise>
                            <p style={{ fontSize: "16px" }}>
                              《家長成長教練組合》
                            </p>
                          </Centralise>
                          <br />
                          <p>
                            你知道嗎？原來和孩子說話是真的能讓孩子的大腦變聰明！研究顯示，發育中的大腦若頻繁接受一來一往的溝通互動刺激，能促進神經元的突觸數增加，讓大腦日後的馬力更強！
                            但是，身為孩子人生的第一個老師，你知道怎麼把握孩子黃金成長嗎？
                            讓我們一起為了孩子而成長！
                          </p>
                          <div style={{ paddingRight: "2.5rem" }}>
                            <ol>
                              1. 線上家長課程x6 + 精美電子書教案 –
                              教你如何幫孩子日常中解鎖理解表達發展。6大主題，共3小時課程。
                              由專業語言治療師專門為家長備課講課。
                              可重複回聽6個月
                            </ol>
                            <ol>
                              2.
                              幼兒語言發育測評x2：涵蓋語言發展5領域，情景式問卷+短語音。10分鐘內自動出結果告知各領域發育情況對應年齡
                              以及適合的居家互動遊戲。每6個月可以複測
                            </ol>
                            <ol>
                              3. 發育教練私人諮詢x1 -預約20分鐘 發育專家諮詢
                            </ol>
                            <ol>
                              4.
                              其他安心好康：若後續需要與語言治療師、職能治療師、行為訓練師諮詢，甚或啟動長期居家介入訓練計劃，均可直接預約享有學員專屬折扣，不需等待。
                            </ol>
                          </div>
                          <Centralise>
                            <button
                              onClick={(e) => {
                                window.open(
                                  "https://tcn.mypenguinsmart.com/growth",
                                  "_blank" // <- This is what makes it open in a new window.
                                );
                              }}
                              style={{
                                textAlign: "center",
                                borderRadius: "50px",
                                backgroundColor: "#6898e3",
                                color: "white",
                                cursor: "pointer",
                                border: "none",
                                padding: "10px 50px 10px 50px",
                                outline: "none",
                              }}
                            >
                              了解課程
                            </button>
                          </Centralise>
                          <br />
                          <Centralise>
                            <p style={{ fontSize: "16px" }}>
                              《CORE-Pro親子互動測評》
                            </p>
                          </Centralise>
                          <br />
                          <p>
                            透過動態問卷與10分鐘語音&親子互動影片，您將可以與資深持證語言治療師進行一對一線上諮商，根據孩子能力與居家互動樣貌，具體的分析並給予您實用的後續訓練建議。
                          </p>
                          <Centralise>
                            <button
                              onClick={(e) => {
                                window.open(
                                  "https://tcn.mypenguinsmart.com/core-pro",
                                  "_blank" // <- This is what makes it open in a new window.
                                );
                              }}
                              style={{
                                textAlign: "center",
                                borderRadius: "50px",
                                backgroundColor: "#6898e3",
                                color: "white",
                                cursor: "pointer",
                                border: "none",
                                padding: "10px 50px 10px 50px",
                                outline: "none",
                              }}
                            >
                              了解更多
                            </button>
                          </Centralise>
                          {this.EndingNotesZHTW(qsResultId)}
                        </div>
                      )}
                      {i18n.language === "zh-CN" && !this.state.pass && (
                        <div>
                          <p>
                            感谢您使用本快筛小工具，根据快筛结果提醒您，孩子可能有发育未达标的疑虑，建议进行进一步排查。
                            作为孩子以后学习能力的基础，推荐您 CORE-Pro 测评
                            评估孩子沟通发展5领域 + 家长引导4面向
                            专家分析+个别咨询
                          </p>
                          <br />
                          <p>
                            由语言发育专家进行深入分析家长自填问卷及10分钟亲子互动视频，综合功能性分析孩子沟通力家长执行力4大方向并给予家长实用日常建议。含30分钟语言治疗师在线家庭谘询。
                          </p>
                          <br />
                          <p>
                            了解更多请透过下方客服加入启儿宝小助理微信 (
                            qierbaohelp )，将有专人为您服务。
                          </p>
                          <br />
                          <Centralise>
                            <h2>关于我们</h2>
                          </Centralise>
                          <br />
                          <p>
                            由哈佛及麻省理工校友创办，启儿宝致力透过科技帮助家长成为孩子发育成长的引路人。透过结合专家洞察力与数据科学，我们协助家长回答两个问题—“我孩子目前发育里程是否正常？”和“若有发育疑虑，我现在可以怎么做？”现从幼儿沟通力发育开始，在线服务担心儿童沟通发育的海内外华人家庭。其个性化数据平台与多元服务不仅有效延展每一专业治疗师的服务范围与人群,更实现“以家庭为核心”的早期疗愈模式，帮助孩子与家庭更快经历突破与持续的进步。
                          </p>
                          <br />
                          <p>
                            启儿宝至今已服务全球36个城市的家庭，也有多个国内外业界专家、奖项背书。不仅与国家儿童医学中心北京儿童医院儿童保健中心联名发表学术研究，有美国硅谷知名加速器Alchemist
                            Accelerator背书其创新发展性，更于2021年入围美“世界前100醫療远见”奖项，致力追求“不论起跑点，为所有孩子与家庭子释出最大人生潜力”的社会企业愿景。
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href="https://qierbao.cn"
                            >
                              qierbao.cn
                            </a>
                          </p>
                        </div>
                      )}
                      {i18n.language === "zh-TW" && !this.state.pass && (
                        <div>
                          <p>
                            感謝您使用本篩查工具。根據本結果提醒您，孩子可能有發育未達標的疑慮，建議您帶孩子至健兒門診或是專業早期兒童發展評估中心進一步獲得臨床評估。
                          </p>
                          <br />
                          <Centralise>
                            <button
                              onClick={(e) => {
                                window.open(
                                  "https://www.hpa.gov.tw/Pages/ashx/File.ashx?FilePath=~/File/Attach/548/File_23966.pdf",
                                  "_blank" // <- This is what makes it open in a new window.
                                );
                              }}
                              style={{
                                textAlign: "center",
                                borderRadius: "50px",
                                backgroundColor: "#6898e3",
                                color: "white",
                                cursor: "pointer",
                                border: "none",
                                padding: "10px 50px 10px 50px",
                                outline: "none",
                              }}
                            >
                              查看周邊兒童發展評估中心
                            </button>
                          </Centralise>
                          <br />
                          <Centralise>
                            <a href="https://www.hpa.gov.tw/Pages/Detail.aspx?nodeid=1602&pid=548">
                              113年度通訊錄 PDF
                              下載。資料來源：衛服部國民健康署網站
                            </a>
                          </Centralise>
                          <br />
                          <br />
                          <Centralise>
                            <p>
                              欲了解更多請聯繫下方客服LINE@ (
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://lin.ee/5TuAhDA"
                              >
                                @penguinsmart
                              </a>
                              )，將有專人為您服務。
                            </p>
                          </Centralise>
                          {this.EndingNotesZHTW(qsResultId)}
                        </div>
                      )}
                    </p>
                  </LandingBodyBox>

                  <Centralise
                    style={{
                      color: "white",
                      fontSize: "14pt",
                      marginTop: "30px",
                    }}
                  >
                    {i18n.language === "zh-TW" ? (
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://tcn.mypenguinsmart.com"
                      >
                        進入官網
                      </a>
                    ) : i18n.language === "zh-CN" ? (
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://qierbao.cn"
                      >
                        进入官网
                      </a>
                    ) : null}
                  </Centralise>
                </Grid.Column>
                <Grid.Column width={isBrowser ? 5 : 1}></Grid.Column>
              </Grid.Row>
            </Grid>
          </LandingBody>
        </SidebarPusher>
        <Footer />
      </div>
    );
  }
}

export default withTranslation()(Results);
